module.exports = __webpack_public_path__ + "static/media/muestrafirmingcream.ea10ebc8.png";